var $448607634f80dccb$exports = {};
$448607634f80dccb$exports = {
  "decrease": function decrease(args) {
    return "\u7E2E\u5C0F ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "\u653E\u5927 ".concat(args.fieldLabel);
  },
  "numberField": "\u6578\u5B57\u6B04\u4F4D"
};
export { $448607634f80dccb$exports as default };